import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ToasterCommonService } from '../../service/toaster-common-service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-profile-image-upload',
  standalone: false,
  templateUrl: './profile-image-upload.html',
  styleUrl: './profile-image-upload.scss'
})
export class ProfileImageUpload  implements OnInit {
  @Output() uploaded = new EventEmitter<string>();

  constructor(private http: HttpClient, private toastr: ToasterCommonService,) {}

  ngOnInit(): void {}

  upload(event:Event): void {
    let files:any = (<FileList>(<HTMLInputElement>event.target).files);
    
    const reader = new FileReader();
    reader.readAsDataURL(files[0]);
    reader.onload = () => {
      const image = new Image();
      image.src = reader.result as string;
      image.onload = () => {
        // 1875,400
        // if(image.naturalWidth==1875 && image.naturalHeight==400){
          const data = new FormData();
          data.append('event_logo', files.item(0));
          data.append('file_size', files.item(0).size);
          data.append('file_type', files.item(0).type);
          this.http.post(`${environment.api}mobile-app/event-wise-profile-upload/`, data).subscribe((res: any) => {
            this.uploaded.emit(res.url);
          });
        // }else{
        //   this.toastr.showError("Please upload only width: 1875 and height: 400", "");
        // }
      };
    };
    
    
  }
}

